<app-section-wrapper-container>
	<div class="overview-sub-section">
		<app-summary-brief
			class="bg-gradient-to-r from-fuchsia-600 via-fuchsia-500 to-purple-400 border border-fuchsia-400"
			[svgIcon]="
				recordCategories | getIconFromOptions: this.recordData().recordCategory
			"
			[title]="'road-taxes|title'"
			[value]="
				this.recordData().recordCategory
					| getTranslationKeyFromValue: recordCategories
					| transloco
			">
			<div class="flex flex-col gap-4">
				<div
					class="flex flex-col sm:flex-row gap-2 items-start md:items-center px-2">
					<app-date-range-pill
						class="-ml-2 text-white"
						[startsAt]="isoDateFrom()"
						[endsAt]="isoDateTo()" />
					<app-expires-at-pill
						class="text-white"
						[endsAt]="recordData()?.endsAt?.toISOString()" />
				</div>
				@if (recordData().externalReference) {
					<div class="brief-item">
						<app-summary-item
							forceWhiteText
							[title]="
								'road-taxes|record|details-section|field-label|external-reference'
							"
							[value]="recordData().externalReference" />
					</div>
				}
			</div>
		</app-summary-brief>
	</div>
	@if (!isNew) {
		<app-module-selector
			[nav]="nav()"
			[isNew]="isNew"
			[recordId]="recordData().id" />
	}

	<div class="flex gap-4 flex-col md:flex-row">
		@if (recordData().vehicleId) {
			<app-vehicle-link-card [id]="recordData().vehicleId" />
		}
	</div>
</app-section-wrapper-container>
